module.exports = __webpack_public_path__ + "img/s (6).ad5c6c6e.png";